import * as Sentry from "@sentry/react";

const isDev = process.env.EXPO_PUBLIC_APP_ENV === 'development';

Sentry.init({
    dsn: "https://9179dd60f6568f075d0a2411296c443d@o4510948862656512.ingest.us.sentry.io/4510951882948608",

    environment: process.env.EXPO_PUBLIC_APP_ENV || 'development',

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    enableLogs: true,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: isDev ? 0 : 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: isDev ? 0 : 1.0,

    tracesSampleRate: isDev ? 1.0 : 0.2,

    tracePropagationTargets: [
        "localhost",
        /^https:\/\/api(-preview)?\.flavrly\.app/,
        /^https:\/\/auth(-preview)?\.flavrly\.app/,
    ],

    integrations: [
        ...(!isDev ? [Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
            maskAllInputs: true,
        })] : []),
        Sentry.browserTracingIntegration(),
    ],
});

export const wrap = (component: any) => component;
export default Sentry;
